import React from 'react';
import { LogOut } from 'lucide-react';
import type { Discipline } from './types';
import { DISCIPLINE_DISPLAY } from './types';
import { formatDay } from './format';
import { dischargeReasonLabel } from '../../../constants/patientLifecycle';

interface DischargedTrackViewProps {
  discipline: Discipline;
  dischargedDate?: string | null;
  /** Patient discharge reason (Overview v3), when the whole patient was discharged */
  dischargeReason?: string | null;
}

const DischargedTrackView: React.FC<DischargedTrackViewProps> = ({ discipline, dischargedDate, dischargeReason }) => (
  <div className="flex flex-col items-center justify-center py-8 text-center text-slate-500">
    <LogOut className="w-8 h-8 mb-2 text-slate-300" aria-hidden="true" />
    <p className="text-sm font-medium text-slate-600">{DISCIPLINE_DISPLAY[discipline] || discipline} discharged</p>
    {dischargedDate && <p className="text-xs mt-1">On {formatDay(dischargedDate, true)}</p>}
    {dischargeReason && <p className="text-xs mt-1">{dischargeReasonLabel(dischargeReason)}</p>}
    <p className="text-xs mt-1 text-slate-400">Read-only</p>
  </div>
);

export default DischargedTrackView;
